
import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSparkles,
  faCaretDown
} from "@fortawesome/pro-solid-svg-icons";
import Dropdown from "../../components/Dropdown";

import "./FilterButton.scss";


export const FilterButtonDropdown = ({options = [], onSelect = ()=>{}, label, children})=>{
    const activatedLabels = options.filter(({active})=>active).map(opt=>opt.label);
    return (
        <div className="filter-button-dropdown-wrapper">
            <Dropdown align='right' activableComponent={children ? children : (
                <div className={classNames('filter-button filter-button-dropdown', {active:options.find(opt=>opt.active && !opt.default)})}><FontAwesomeIcon icon={faSparkles} /> {label || activatedLabels.join(' & ')} <FontAwesomeIcon icon={faCaretDown} /></div>
            )}>
                <ul className="dropdown-menu">
                    {options.map(({label, active = false, data={}}, key)=>(
                        <li key={key} className={classNames('menu-item', {active})}
                            onClick={() => {
                                onSelect(data)
                            }} >
                                {typeof label === 'function' ? label(active) : label}
                        </li>
                    ))}
                </ul>
            </Dropdown>
        </div>

    )
}

export const FilterButtonToggle = ({active = false, onToggle = ()=>{}, label})=>{
    return (
        <div className={classNames('filter-button filter-button-toggle', {active})} onClick={onToggle}>
            <FontAwesomeIcon icon={faSparkles} /> {label || 'filtres'}
            <div className={classNames('filter-button-toggle-slider-wrapper', {active})}>
                <span className="filter-button-toggle-slider"></span>
            </div>
        </div>
    )
}